import { render } from "./HeroiconsOutlineLogout.vue?vue&type=template&id=cd737f14"
const script = {}

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLogout.vue"]])

export default __exports__